module.exports = __webpack_public_path__ + "static/img/4.5725b4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/4.png
// module id = i5rW
// module chunks = 0